import { z } from 'zod';

export const StockReplyScalarFieldEnumSchema = z.enum(['stockreplyId','cityId','defaultSet','stockName','stockText','personId','departmentId','classificationId']);

export default StockReplyScalarFieldEnumSchema;
